import {
  BarChart3,
  BookOpen,
  Briefcase,
  Building2,
  CalendarClock,
  CalendarDays,
  CalendarRange,
  ClipboardCheck,
  ClipboardList,
  CreditCard,
  FileCheck2,
  FileSpreadsheet,
  FileText,
  LayoutDashboard,
  LayoutGrid,
  MessageSquare,
  Percent,
  School,
  ScrollText,
  ShieldCheck,
  Tags,
  UserCog,
  Users,
  UsersRound,
} from 'lucide-react'

export interface NavigationItem {
  label: string
  path: string
  permission: string
  icon: any
  exact?: boolean
  children?: NavigationItem[]
}

export interface NavigationSection {
  title: string
  items: NavigationItem[]
}

export const navigationConfig: NavigationSection[] = [
  {
    title: 'Main',
    items: [
      {
        label: 'Dashboard',
        path: '/dashboard',
        permission: 'dashboard:view',
        icon: LayoutDashboard,
      },
    ],
  },
  {
    title: 'Front Office',
    items: [
      {
        label: 'Student Directory',
        path: '/admin/student-directory',
        permission: 'student-directory:view',
        icon: Users,
      },
      {
        label: 'Document Verification',
        path: '/admin/document-verification',
        permission: 'document-verification:view',
        icon: FileCheck2,
      },
      {
        label: 'Staff Directory',
        path: '/admin/frontoffice/staff-directory',
        permission: 'staff-directory:view',
        icon: Briefcase,
      },
      {
        label: 'Seat Management',
        path: '/admin/enrollment/seat-management',
        permission: 'seat-management:view',
        icon: LayoutGrid,
      },
    ],
  },
  {
    title: 'Academic Management',
    items: [
      {
        label: 'Academics',
        path: '/admin/academics',
        permission: 'academics:view',
        icon: School,
        exact: true,
      },
      {
        label: 'Calendar',
        path: '/admin/events-calendar',
        permission: 'academics:view',
        icon: CalendarDays,
      },
      {
        label: 'Subject Management',
        path: '/admin/academics/subject-management',
        permission: 'subjects:view',
        icon: BookOpen,
      },
      {
        label: 'Timetable',
        path: '/academics/timetable',
        permission: 'timetable:view',
        icon: CalendarRange,
      },
      {
        label: 'Attendance',
        path: '/teacher/attendence',
        permission: 'attendance:view',
        icon: CalendarDays,
      },
      {
        label: 'Assignments',
        path: '/teacher/assignments',
        permission: 'assignments:view',
        icon: FileText,
      },
      {
        label: 'Lesson Plans',
        path: '/teacher/lessonplans',
        permission: 'lesson-plans:view',
        icon: ScrollText,
      },
    ],
  },
  {
    title: 'Class Management',
    items: [
      {
        label: 'My Classes',
        path: '/teacher/myclasses',
        permission: 'class-management:view',
        icon: ClipboardCheck,
      },
      {
        label: 'Classes',
        path: '/admin/class-management/classes',
        permission: 'class-management:view',
        icon: ClipboardCheck,
      },
      /*
      {
        label: 'Pending Queue',
        path: '/admin/class-management/pending-queue',
        permission: 'class-management:view',
        icon: CalendarClock,
      },
      */
    ],
  },
  {
    title: 'Finance Management',
    items: [
      {
        label: 'Fees & Finance',
        path: '/admin/finance/fees-finance',
        permission: 'finance:view',
        icon: CreditCard,
        children: [
          {
            label: 'Overview',
            path: '/admin/finance/fees-finance/overview',
            permission: 'finance:view',
            icon: LayoutDashboard,
          },
          {
            label: 'Fee Head',
            path: '/admin/finance/fees-finance/fee-head',
            permission: 'finance:view',
            icon: Tags,
          },
          {
            label: 'Fee Structure',
            path: '/admin/finance/fees-finance/fee-structure',
            permission: 'finance:view',
            icon: FileSpreadsheet,
          },
          {
            label: 'Fee Collection',
            path: '/admin/finance/fees-finance/payments',
            permission: 'finance:view',
            icon: CreditCard,
          },
          {
            label: 'Discounts',
            path: '/admin/finance/fees-finance/discounts',
            permission: 'finance:view',
            icon: Percent,
          },
          {
            label: 'Fee Reports',
            path: '/admin/finance/fees-finance/reports',
            permission: 'finance:view',
            icon: BarChart3,
          },
          {
            label: 'Approvals',
            path: '/admin/finance/fees-finance/approvals',
            permission: 'finance:view',
            icon: ClipboardCheck,
          },
        ],
      },
    ],
  },
  {
    title: 'Communication',
    items: [
      {
        label: 'Communication',
        path: '/communication',
        permission: 'communication:view',
        icon: MessageSquare,
        children: [
          {
            label: 'Message',
            path: '/communication/message',
            permission: 'communication:view',
            icon: MessageSquare,
          },
          {
            label: 'Notices',
            path: '/communication/notices',
            permission: 'communication:view',
            icon: ClipboardList,
          },
          {
            label: 'Groups',
            path: '/communication/groups',
            permission: 'communication:view',
            icon: UsersRound,
          },
        ],
      },
    ],
  },
  {
    title: 'User & Role Management',
    items: [
      {
        label: 'User Management',
        path: '/admin/user-management',
        permission: 'user-management:view',
        icon: UserCog,
      },
      {
        label: 'Role Management',
        path: '/admin/user-management/role-management',
        permission: 'role-management:view',
        icon: ShieldCheck,
      },
      {
        label: 'Departments',
        path: '/admin/user-management/departments',
        permission: 'departments:view',
        icon: Building2,
      },
      {
        label: 'Designations',
        path: '/admin/user-management/designations',
        permission: 'designations:view',
        icon: Briefcase,
      },
    ],
  },
]
